<template>
    <common-content-spacer height="super-huge">
        <common-content-wrapper width="huge">
            <div class="availability-full-calendar__header">
                <div class="availability-full-calendar__months-input">
                    <!-- To be continued once MVP is done.
                    <select-input
                        :value="selectedCalendarOption"
                        :options="calenarOptions"
                        @change="changeCurrentMonth($event)"
                    ></select-input>
                    -->
                </div>
                <slot></slot>
            </div>
        </common-content-wrapper>
        <common-content-wrapper v-if="selectedCalendarOption === 'Month'" width="huge">
            <month-calendar
                :year="year"
                :month="month"
                :dates="dates"
                :physician="physician"
                :practice="practice"
                :showCancelled="showCancelled"
                @emitEvent="emitEvent($event)"
            ></month-calendar>
        </common-content-wrapper>
        <week-calendar v-else-if="selectedCalendarOption === 'Week'" :year="year" :month="month"></week-calendar>
        <day-calendar v-else></day-calendar>
    </common-content-spacer>
</template>

<script>
    import DayCalendar from './AvailabilityDayCalendar'
    import WeekCalendar from './AvailabilityWeekCalendar'
    import MonthCalendar from './AvailabilityMonthCalendar'

    export default {
        components: {
            DayCalendar,
            WeekCalendar,
            MonthCalendar,
        },

        props: {
            year: { type: Number, required: true },
            month: { type: Number, required: true },
            dates: { type: Object, required: true },
            physician: { type: Object, required: true },
            practice: { type: Object, required: true },
            showCancelled: { type: Boolean, required: true },
        },

        data() {
            return {
                selectedCalendarOption: 'Month',
            }
        },

        computed: {
            calenarOptions() {
                return [
                    { label: 'Month', value: 'Month' },
                    { label: 'Week', value: 'Week' },
                    { label: 'Day', value: 'Day' },
                ]
            },
        },

        methods: {
            changeCurrentMonth(ev) {
                this.selectedCalendarOption = ev
            },
        },
    }
</script>
